export const API_ERROR_MESSAGE = 'Something Went Wrong!';
export const CURRENCY_SYMBOL ='$';